module.exports = __webpack_public_path__ + "media/images/printes-top-86d4890151aeb375009c83f8636c54d3.svg";